{
  "address": "SBondMDrcV3K4kxZR1HNVT7osZxAHVHgYXL5Ze1oMUv",
  "metadata": {
    "name": "sb_on_demand",
    "version": "0.1.0",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "guardian_quote_verify",
      "discriminator": [168, 36, 93, 156, 157, 150, 148, 45],
      "accounts": [
        { "name": "guardian", "writable": true },
        { "name": "oracle", "writable": true },
        { "name": "authority", "signer": true, "relations": ["oracle"] },
        { "name": "guardian_queue", "writable": true, "relations": ["state"] },
        { "name": "state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "GuardianQuoteVerifyParams" } }
        }
      ]
    },
    {
      "name": "guardian_register",
      "discriminator": [159, 76, 53, 117, 219, 29, 116, 135],
      "accounts": [
        { "name": "oracle", "writable": true },
        { "name": "state" },
        { "name": "guardian_queue", "relations": ["state"] },
        { "name": "authority", "signer": true, "relations": ["state"] }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "GuardianRegisterParams" } }
        }
      ]
    },
    {
      "name": "guardian_unregister",
      "discriminator": [215, 19, 61, 120, 155, 224, 120, 60],
      "accounts": [
        { "name": "oracle", "writable": true },
        { "name": "state" },
        { "name": "guardian_queue", "writable": true, "relations": ["state"] },
        { "name": "authority", "signer": true, "relations": ["state"] }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "GuardianUnregisterParams" } }
        }
      ]
    },
    {
      "name": "oracle_heartbeat",
      "discriminator": [10, 175, 217, 130, 111, 35, 117, 54],
      "accounts": [
        { "name": "oracle", "writable": true },
        {
          "name": "oracle_stats",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [79, 114, 97, 99, 108, 101, 83, 116, 97, 116, 115]
              },
              { "kind": "account", "path": "oracle" }
            ]
          }
        },
        { "name": "oracle_signer", "signer": true },
        {
          "name": "queue",
          "writable": true,
          "relations": ["oracle", "gc_node"]
        },
        { "name": "gc_node", "writable": true },
        { "name": "program_state", "writable": true },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "native_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "queue_escrow", "writable": true },
        { "name": "stake_program" },
        { "name": "delegation_pool" },
        { "name": "delegation_group" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleHeartbeatParams" } }
        }
      ]
    },
    {
      "name": "oracle_heartbeat_v2",
      "discriminator": [122, 231, 66, 32, 226, 62, 144, 103],
      "accounts": [
        { "name": "oracle", "writable": true },
        {
          "name": "oracle_stats",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [79, 114, 97, 99, 108, 101, 83, 116, 97, 116, 115]
              },
              { "kind": "account", "path": "oracle" }
            ]
          }
        },
        { "name": "oracle_signer", "signer": true },
        {
          "name": "queue",
          "writable": true,
          "relations": ["oracle", "gc_node"]
        },
        { "name": "gc_node", "writable": true },
        { "name": "program_state", "writable": true }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleHeartbeatV2Params" } }
        }
      ]
    },
    {
      "name": "oracle_init",
      "discriminator": [21, 158, 66, 65, 60, 221, 148, 61],
      "accounts": [
        { "name": "oracle", "writable": true, "signer": true },
        {
          "name": "oracle_stats",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [79, 114, 97, 99, 108, 101, 83, 116, 97, 116, 115]
              },
              { "kind": "account", "path": "oracle" }
            ]
          }
        },
        { "name": "program_state", "writable": true },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleInitParams" } }
        }
      ]
    },
    {
      "name": "oracle_init_svm",
      "discriminator": [106, 20, 36, 117, 166, 175, 131, 83],
      "accounts": [
        {
          "name": "oracle",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "const", "value": [79, 114, 97, 99, 108, 101] },
              { "kind": "arg", "path": "params.queue" },
              { "kind": "arg", "path": "params.source_oracle_key" }
            ]
          }
        },
        {
          "name": "oracle_stats",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [79, 114, 97, 99, 108, 101, 83, 116, 97, 116, 115]
              },
              { "kind": "account", "path": "oracle" }
            ]
          }
        },
        { "name": "program_state", "writable": true },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        },
        { "name": "stake_program" },
        { "name": "stake_pool" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleInitSVMParams" } }
        }
      ]
    },
    {
      "name": "oracle_reset_lut",
      "discriminator": [147, 244, 108, 198, 152, 219, 0, 22],
      "accounts": [
        { "name": "oracle", "writable": true },
        { "name": "authority", "signer": true, "relations": ["oracle"] },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "program_state" },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleResetLutParams" } }
        }
      ]
    },
    {
      "name": "oracle_set_configs",
      "discriminator": [129, 111, 223, 4, 191, 188, 70, 180],
      "accounts": [
        { "name": "oracle" },
        { "name": "authority", "signer": true, "relations": ["oracle"] }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleSetConfigsParams" } }
        }
      ]
    },
    {
      "name": "oracle_set_operator",
      "discriminator": [210, 232, 155, 124, 69, 176, 242, 133],
      "accounts": [
        { "name": "oracle", "writable": true },
        { "name": "authority", "signer": true, "relations": ["oracle"] },
        { "name": "operator" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleSetOperatorParams" } }
        }
      ]
    },
    {
      "name": "oracle_sync_lut",
      "discriminator": [138, 99, 12, 59, 18, 170, 171, 45],
      "accounts": [
        { "name": "oracle" },
        { "name": "queue", "relations": ["oracle"] },
        { "name": "ncn" },
        { "name": "vault" },
        { "name": "state" },
        { "name": "authority", "signer": true, "relations": ["oracle"] },
        { "name": "operator", "relations": ["oracle"] },
        { "name": "ncn_operator_state" },
        { "name": "operator_vault_ticket" },
        { "name": "vault_operator_delegation" },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        },
        { "name": "payer", "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "OracleSyncLutParams" } }
        }
      ]
    },
    {
      "name": "permission_set",
      "discriminator": [211, 122, 185, 120, 129, 182, 55, 103],
      "accounts": [
        { "name": "authority", "signer": true },
        { "name": "granter" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PermissionSetParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_close",
      "discriminator": [19, 134, 50, 142, 177, 215, 196, 83],
      "accounts": [
        { "name": "pull_feed", "writable": true },
        { "name": "reward_escrow", "writable": true },
        { "name": "lut", "writable": true },
        { "name": "lut_signer" },
        { "name": "payer", "writable": true, "signer": true },
        { "name": "state" },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["pull_feed"]
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedCloseParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_init",
      "discriminator": [198, 130, 53, 198, 235, 61, 143, 40],
      "accounts": [
        { "name": "pull_feed", "writable": true, "signer": true },
        { "name": "queue" },
        { "name": "authority" },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "program_state" },
        {
          "name": "reward_escrow",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "pull_feed" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "wrapped_sol_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "wrapped_sol_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedInitParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_set_configs",
      "discriminator": [217, 45, 11, 246, 64, 26, 82, 168],
      "accounts": [
        { "name": "pull_feed", "writable": true },
        { "name": "authority", "signer": true, "relations": ["pull_feed"] }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedSetConfigsParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_submit_response",
      "discriminator": [150, 22, 215, 166, 143, 93, 48, 137],
      "accounts": [
        { "name": "feed", "writable": true },
        { "name": "queue", "relations": ["feed"] },
        { "name": "program_state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "reward_vault", "writable": true },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_mint",
          "address": "So11111111111111111111111111111111111111112"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedSubmitResponseParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_submit_response_consensus",
      "discriminator": [239, 124, 39, 184, 147, 222, 16, 248],
      "accounts": [
        { "name": "queue" },
        { "name": "program_state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "reward_vault", "writable": true },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        {
          "name": "ix_sysvar",
          "address": "Sysvar1nstructions1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": { "name": "PullFeedSubmitResponseConsensusParams" }
          }
        }
      ]
    },
    {
      "name": "pull_feed_submit_response_consensus_light",
      "discriminator": [178, 179, 88, 144, 175, 130, 157, 87],
      "accounts": [
        { "name": "queue" },
        { "name": "program_state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        {
          "name": "ix_sysvar",
          "address": "Sysvar1nstructions1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": { "name": "PullFeedSubmitResponseConsensusLightParams" }
          }
        }
      ]
    },
    {
      "name": "pull_feed_submit_response_many",
      "discriminator": [47, 156, 45, 25, 200, 71, 37, 215],
      "accounts": [
        { "name": "queue" },
        { "name": "program_state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "reward_vault", "writable": true },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_mint",
          "address": "So11111111111111111111111111111111111111112"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedSubmitResponseManyParams" } }
        }
      ]
    },
    {
      "name": "pull_feed_submit_response_svm",
      "discriminator": [123, 7, 190, 12, 220, 230, 198, 148],
      "accounts": [
        { "name": "feed", "writable": true },
        {
          "name": "queue",
          "pda": {
            "seeds": [
              { "kind": "const", "value": [81, 117, 101, 117, 101] },
              { "kind": "arg", "path": "params.source_queue_key" }
            ]
          },
          "relations": ["feed"]
        },
        { "name": "program_state" },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "reward_vault", "writable": true },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_mint",
          "address": "So11111111111111111111111111111111111111112"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "PullFeedSubmitResponseSVMParams" } }
        }
      ]
    },
    {
      "name": "queue_add_mr_enclave",
      "discriminator": [199, 255, 81, 50, 60, 133, 171, 138],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "program_authority" },
        { "name": "state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueAddMrEnclaveParams" } }
        }
      ]
    },
    {
      "name": "queue_allow_subsidies",
      "discriminator": [94, 203, 82, 157, 188, 138, 202, 108],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true, "relations": ["state"] },
        { "name": "state", "writable": true }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueAllowSubsidiesParams" } }
        }
      ]
    },
    {
      "name": "queue_garbage_collect",
      "discriminator": [187, 208, 104, 247, 16, 91, 96, 98],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "oracle", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueGarbageCollectParams" } }
        }
      ]
    },
    {
      "name": "queue_init",
      "discriminator": [144, 18, 99, 145, 133, 27, 207, 13],
      "accounts": [
        { "name": "queue", "writable": true, "signer": true },
        {
          "name": "queue_escrow",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "queue" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "native_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        { "name": "authority" },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "native_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "program_state" },
        { "name": "lut_signer", "writable": true },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueInitParams" } }
        }
      ]
    },
    {
      "name": "queue_init_svm",
      "discriminator": [175, 94, 119, 151, 45, 144, 173, 235],
      "accounts": [
        {
          "name": "queue",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "const", "value": [81, 117, 101, 117, 101] },
              { "kind": "arg", "path": "params.source_queue_key" }
            ]
          }
        },
        {
          "name": "queue_escrow",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "queue" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "native_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        { "name": "authority" },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "native_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "program_state" },
        { "name": "lut_signer", "writable": true },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueInitSVMParams" } }
        }
      ]
    },
    {
      "name": "queue_override_svm",
      "discriminator": [43, 103, 15, 35, 89, 14, 244, 165],
      "accounts": [
        { "name": "oracle", "writable": true },
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueOverrideSVMParams" } }
        }
      ]
    },
    {
      "name": "queue_pay_subsidy",
      "discriminator": [85, 84, 51, 251, 144, 57, 105, 200],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "program_state" },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "vault" },
        {
          "name": "reward_vault",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "vault" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "switch_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "subsidy_vault",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "program_state" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "switch_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "wsol_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "switch_mint" },
        { "name": "vault_config" },
        { "name": "payer", "writable": true, "signer": true }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueuePaySubsidyParams" } }
        }
      ]
    },
    {
      "name": "queue_remove_mr_enclave",
      "discriminator": [3, 64, 135, 33, 190, 133, 68, 252],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "program_authority" },
        { "name": "state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueRemoveMrEnclaveParams" } }
        }
      ]
    },
    {
      "name": "queue_reset_vault",
      "discriminator": [232, 255, 48, 111, 240, 168, 253, 40],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" },
        { "name": "ncn", "relations": ["queue"] },
        { "name": "vault" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueResetVaultParams" } }
        }
      ]
    },
    {
      "name": "queue_set_configs",
      "discriminator": [54, 183, 243, 199, 49, 103, 142, 48],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueSetConfigsParams" } }
        }
      ]
    },
    {
      "name": "queue_set_ncn",
      "discriminator": [232, 223, 179, 12, 20, 136, 181, 219],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" },
        { "name": "ncn" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueSetNcnParams" } }
        }
      ]
    },
    {
      "name": "queue_set_vault",
      "discriminator": [48, 47, 102, 99, 241, 249, 196, 246],
      "accounts": [
        { "name": "queue", "writable": true },
        { "name": "authority", "signer": true },
        { "name": "state" },
        { "name": "ncn", "relations": ["queue"] },
        { "name": "vault" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "QueueSetVaultParams" } }
        }
      ]
    },
    {
      "name": "randomness_commit",
      "discriminator": [52, 170, 152, 201, 179, 133, 242, 141],
      "accounts": [
        { "name": "randomness", "writable": true },
        { "name": "queue", "relations": ["randomness", "oracle"] },
        { "name": "oracle", "writable": true },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        { "name": "authority", "signer": true, "relations": ["randomness"] }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "RandomnessCommitParams" } }
        }
      ]
    },
    {
      "name": "randomness_init",
      "discriminator": [9, 9, 204, 33, 50, 116, 113, 15],
      "accounts": [
        { "name": "randomness", "writable": true, "signer": true },
        {
          "name": "reward_escrow",
          "writable": true,
          "pda": {
            "seeds": [
              { "kind": "account", "path": "randomness" },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206,
                  235, 121, 172, 28, 180, 133, 237, 95, 91, 55, 145, 58, 140,
                  245, 133, 126, 255, 0, 169
                ]
              },
              { "kind": "account", "path": "wrapped_sol_mint" }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        { "name": "authority", "signer": true },
        { "name": "queue", "writable": true },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "wrapped_sol_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "program_state" },
        { "name": "lut_signer" },
        { "name": "lut", "writable": true },
        {
          "name": "address_lookup_table_program",
          "address": "AddressLookupTab1e1111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "RandomnessInitParams" } }
        }
      ]
    },
    {
      "name": "randomness_reveal",
      "discriminator": [197, 181, 187, 10, 30, 58, 20, 73],
      "accounts": [
        { "name": "randomness", "writable": true },
        { "name": "oracle", "relations": ["randomness"] },
        { "name": "queue", "relations": ["oracle"] },
        {
          "name": "stats",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  79, 114, 97, 99, 108, 101, 82, 97, 110, 100, 111, 109, 110,
                  101, 115, 115, 83, 116, 97, 116, 115
                ]
              },
              { "kind": "account", "path": "oracle" }
            ]
          }
        },
        { "name": "authority", "signer": true, "relations": ["randomness"] },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "recent_slothashes",
          "address": "SysvarS1otHashes111111111111111111111111111"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        { "name": "reward_escrow", "writable": true },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "wrapped_sol_mint",
          "address": "So11111111111111111111111111111111111111112"
        },
        { "name": "program_state" }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "RandomnessRevealParams" } }
        }
      ]
    },
    {
      "name": "state_init",
      "discriminator": [103, 241, 106, 190, 217, 153, 87, 105],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [{ "kind": "const", "value": [83, 84, 65, 84, 69] }]
          }
        },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "StateInitParams" } }
        }
      ]
    },
    {
      "name": "state_set_configs",
      "discriminator": [40, 98, 76, 37, 206, 9, 47, 144],
      "accounts": [
        { "name": "state", "writable": true },
        { "name": "authority", "signer": true, "relations": ["state"] },
        { "name": "queue", "writable": true },
        { "name": "payer", "writable": true, "signer": true },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "StateSetConfigsParams" } }
        }
      ]
    },
    {
      "name": "test_update_oracle_stats",
      "discriminator": [175, 48, 162, 252, 154, 197, 149, 187],
      "accounts": [
        {
          "name": "oracle_stats",
          "docs": ["The OracleStats account to update."],
          "writable": true
        }
      ],
      "args": [
        {
          "name": "params",
          "type": { "defined": { "name": "TestUpdateOracleStatsParams" } }
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "OracleAccountData",
      "discriminator": [128, 30, 16, 241, 170, 73, 55, 54]
    },
    {
      "name": "OracleStatsAccountData",
      "discriminator": [180, 157, 178, 234, 240, 27, 152, 179]
    },
    {
      "name": "PullFeedAccountData",
      "discriminator": [196, 27, 108, 196, 10, 215, 219, 40]
    },
    {
      "name": "QueueAccountData",
      "discriminator": [217, 194, 55, 127, 184, 83, 138, 1]
    },
    {
      "name": "RandomnessAccountData",
      "discriminator": [10, 66, 229, 135, 220, 239, 217, 114]
    },
    { "name": "State", "discriminator": [216, 146, 107, 94, 104, 75, 182, 177] }
  ],
  "events": [
    {
      "name": "CostWhitelistEvent",
      "discriminator": [56, 107, 191, 127, 116, 6, 138, 149]
    },
    {
      "name": "GarbageCollectionEvent",
      "discriminator": [232, 235, 2, 188, 8, 143, 145, 237]
    },
    {
      "name": "GuardianQuoteVerifyEvent",
      "discriminator": [31, 37, 39, 6, 214, 186, 33, 115]
    },
    {
      "name": "OracleHeartbeatEvent",
      "discriminator": [52, 29, 166, 2, 94, 7, 188, 13]
    },
    {
      "name": "OracleInitEvent",
      "discriminator": [89, 193, 219, 200, 1, 83, 167, 24]
    },
    {
      "name": "OracleQuoteOverrideEvent",
      "discriminator": [78, 204, 191, 210, 164, 196, 244, 65]
    },
    {
      "name": "OracleQuoteRotateEvent",
      "discriminator": [26, 189, 196, 192, 225, 127, 26, 228]
    },
    {
      "name": "OracleQuoteVerifyRequestEvent",
      "discriminator": [203, 209, 79, 0, 20, 71, 226, 202]
    },
    {
      "name": "PermissionSetEvent",
      "discriminator": [148, 86, 123, 0, 102, 20, 119, 206]
    },
    {
      "name": "PullFeedErrorValueEvent",
      "discriminator": [225, 80, 192, 95, 14, 12, 83, 192]
    },
    {
      "name": "PullFeedValueEvents",
      "discriminator": [86, 7, 231, 28, 122, 161, 117, 69]
    },
    {
      "name": "QueueAddMrEnclaveEvent",
      "discriminator": [170, 186, 175, 38, 216, 51, 69, 175]
    },
    {
      "name": "QueueInitEvent",
      "discriminator": [44, 137, 99, 227, 107, 8, 30, 105]
    },
    {
      "name": "QueueRemoveMrEnclaveEvent",
      "discriminator": [4, 105, 196, 60, 84, 122, 203, 196]
    },
    {
      "name": "RandomnessCommitEvent",
      "discriminator": [88, 60, 172, 90, 112, 10, 206, 147]
    }
  ],
  "errors": [
    { "code": 6000, "name": "GenericError" },
    { "code": 6001, "name": "InvalidQuote" },
    { "code": 6002, "name": "InsufficientQueue" },
    { "code": 6003, "name": "QueueFull" },
    { "code": 6004, "name": "InvalidEnclaveSigner" },
    { "code": 6005, "name": "InvalidSigner" },
    { "code": 6006, "name": "MrEnclaveAlreadyExists" },
    { "code": 6007, "name": "MrEnclaveAtCapacity" },
    { "code": 6008, "name": "MrEnclaveDoesntExist" },
    { "code": 6009, "name": "PermissionDenied" },
    { "code": 6010, "name": "InvalidQueue" },
    { "code": 6011, "name": "IncorrectMrEnclave" },
    { "code": 6012, "name": "InvalidAuthority" },
    { "code": 6013, "name": "InvalidMrEnclave" },
    { "code": 6014, "name": "InvalidTimestamp" },
    { "code": 6015, "name": "InvalidOracleIdx" },
    { "code": 6016, "name": "InvalidSecpSignature" },
    { "code": 6017, "name": "InvalidGuardianQueue" },
    { "code": 6018, "name": "InvalidIndex" },
    { "code": 6019, "name": "InvalidOracleQueue" },
    { "code": 6020, "name": "InvalidPermission" },
    { "code": 6021, "name": "InvalidePermissionedAccount" },
    { "code": 6022, "name": "InvalidEpochRotate" },
    { "code": 6023, "name": "InvalidEpochFinalize" },
    { "code": 6024, "name": "InvalidEscrow" },
    { "code": 6025, "name": "IllegalOracle" },
    { "code": 6026, "name": "IllegalExecuteAttempt" },
    { "code": 6027, "name": "IllegalFeedValue" },
    { "code": 6028, "name": "InvalidOracleFeedStats" },
    { "code": 6029, "name": "InvalidStateAuthority" },
    { "code": 6030, "name": "NotEnoughSamples" },
    { "code": 6031, "name": "OracleIsVerified" },
    { "code": 6032, "name": "QueueIsEmpty" },
    { "code": 6033, "name": "SecpRecoverFailure" },
    { "code": 6034, "name": "StaleSample" },
    { "code": 6035, "name": "SwitchboardRandomnessTooOld" },
    { "code": 6036, "name": "EpochIdMismatch" },
    { "code": 6037, "name": "GuardianAlreadyVoted" },
    { "code": 6038, "name": "RandomnessNotRequested" },
    { "code": 6039, "name": "InvalidSlotNumber" },
    { "code": 6040, "name": "RandomnessOracleKeyExpired" },
    { "code": 6041, "name": "InvalidAdvisory" },
    { "code": 6042, "name": "InvalidOracleStats" },
    { "code": 6043, "name": "InvalidStakeProgram" },
    { "code": 6044, "name": "InvalidStakePool" },
    { "code": 6045, "name": "InvalidDelegationPool" },
    { "code": 6046, "name": "UnparsableAccount" },
    { "code": 6047, "name": "InvalidInstruction" },
    { "code": 6048, "name": "OracleAlreadyVerified" },
    { "code": 6049, "name": "GuardianNotVerified" },
    { "code": 6050, "name": "InvalidConstraint" },
    { "code": 6051, "name": "InvalidDelegationGroup" },
    { "code": 6052, "name": "OracleKeyNotFound" },
    { "code": 6053, "name": "GuardianReregisterAttempt" },
    { "code": 6054, "name": "InvalidManySubmissionCount" },
    { "code": 6055, "name": "MissingSecpIx" },
    { "code": 6056, "name": "ChecksumMismatch" },
    { "code": 6057, "name": "InvalidSubmissionFeedsCount" },
    { "code": 6058, "name": "InvalidSecpSignatureOraclesCount" },
    { "code": 6059, "name": "InvalidEthAddress" },
    { "code": 6060, "name": "NoLutKeysAdded" },
    { "code": 6061, "name": "InvalidVaultOperatorDelegation" },
    { "code": 6062, "name": "InvalidVaultTokenAccount" },
    { "code": 6063, "name": "InvalidRemainingAccounts" },
    { "code": 6064, "name": "SubsidiesNotAllowed" },
    { "code": 6065, "name": "MissingVod" },
    { "code": 6066, "name": "InvalidVodEpoch" },
    { "code": 6067, "name": "InvalidOracleSubsidyWallet" },
    { "code": 6068, "name": "InvalidOperator" },
    { "code": 6069, "name": "Max128SampleValue" },
    { "code": 6070, "name": "RewardAlreadyPaid" }
  ],
  "types": [
    {
      "name": "CompactResult",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "std_dev",
            "docs": [
              "The standard deviation of the submissions needed for quorom size"
            ],
            "type": "f32"
          },
          {
            "name": "mean",
            "docs": ["The mean of the submissions needed for quorom size"],
            "type": "f32"
          },
          {
            "name": "slot",
            "docs": ["The slot at which this value was signed."],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "CostWhitelistEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "feeds", "type": { "vec": "pubkey" } },
          { "name": "oracles", "type": { "vec": "pubkey" } },
          { "name": "values", "type": { "vec": { "vec": "i128" } } },
          { "name": "reward", "type": "u32" }
        ]
      }
    },
    {
      "name": "CurrentResult",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "value",
            "docs": [
              "The median value of the submissions needed for quorom size"
            ],
            "type": "i128"
          },
          {
            "name": "std_dev",
            "docs": [
              "The standard deviation of the submissions needed for quorom size"
            ],
            "type": "i128"
          },
          {
            "name": "mean",
            "docs": ["The mean of the submissions needed for quorom size"],
            "type": "i128"
          },
          {
            "name": "range",
            "docs": ["The range of the submissions needed for quorom size"],
            "type": "i128"
          },
          {
            "name": "min_value",
            "docs": [
              "The minimum value of the submissions needed for quorom size"
            ],
            "type": "i128"
          },
          {
            "name": "max_value",
            "docs": [
              "The maximum value of the submissions needed for quorom size"
            ],
            "type": "i128"
          },
          {
            "name": "num_samples",
            "docs": ["The number of samples used to calculate this result"],
            "type": "u8"
          },
          {
            "name": "submission_idx",
            "docs": [
              "The index of the submission that was used to calculate this result"
            ],
            "type": "u8"
          },
          { "name": "padding1", "type": { "array": ["u8", 6] } },
          {
            "name": "slot",
            "docs": ["The slot at which this value was signed."],
            "type": "u64"
          },
          {
            "name": "min_slot",
            "docs": [
              "The slot at which the first considered submission was made"
            ],
            "type": "u64"
          },
          {
            "name": "max_slot",
            "docs": [
              "The slot at which the last considered submission was made"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "GarbageCollectionEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "oracle", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "GuardianQuoteVerifyEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "quote", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" },
          { "name": "oracle", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "GuardianQuoteVerifyParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "timestamp", "type": "i64" },
          { "name": "mr_enclave", "type": { "array": ["u8", 32] } },
          { "name": "_reserved1", "type": "u32" },
          { "name": "ed25519_key", "type": "pubkey" },
          { "name": "secp256k1_key", "type": { "array": ["u8", 64] } },
          { "name": "slot", "type": "u64" },
          { "name": "signature", "type": { "array": ["u8", 64] } },
          { "name": "recovery_id", "type": "u8" },
          { "name": "advisories", "type": { "vec": "u32" } }
        ]
      }
    },
    {
      "name": "GuardianRegisterParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "GuardianUnregisterParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "MegaSlotInfo",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "reserved1", "type": "u64" },
          { "name": "slot_end", "type": "u64" },
          { "name": "perf_goal", "type": "i64" },
          { "name": "current_signature_count", "type": "i64" }
        ]
      }
    },
    {
      "name": "MultiSubmission",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "values", "type": { "vec": "i128" } },
          { "name": "signature", "type": { "array": ["u8", 64] } },
          { "name": "recovery_id", "type": "u8" }
        ]
      }
    },
    {
      "name": "OracleAccountData",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "enclave",
            "docs": ["Represents the state of the quote verifiers enclave."],
            "type": { "defined": { "name": "Quote" } }
          },
          {
            "name": "authority",
            "docs": [
              "The authority of the EnclaveAccount which is permitted to make account changes."
            ],
            "type": "pubkey"
          },
          {
            "name": "queue",
            "docs": [
              "Queue used for attestation to verify a MRENCLAVE measurement."
            ],
            "type": "pubkey"
          },
          {
            "name": "created_at",
            "docs": ["The unix timestamp when the quote was created."],
            "type": "i64"
          },
          {
            "name": "last_heartbeat",
            "docs": ["The last time the quote heartbeated on-chain."],
            "type": "i64"
          },
          { "name": "secp_authority", "type": { "array": ["u8", 64] } },
          {
            "name": "gateway_uri",
            "docs": ["URI location of the verifier's gateway."],
            "type": { "array": ["u8", 64] }
          },
          { "name": "permissions", "type": "u64" },
          {
            "name": "is_on_queue",
            "docs": [
              "Whether the quote is located on the AttestationQueues buffer."
            ],
            "type": "u8"
          },
          { "name": "_padding1", "type": { "array": ["u8", 7] } },
          { "name": "lut_slot", "type": "u64" },
          { "name": "last_reward_epoch", "type": "u64" },
          { "name": "operator", "type": "pubkey" },
          { "name": "_ebuf3", "type": { "array": ["u8", 16] } },
          { "name": "_ebuf2", "type": { "array": ["u8", 64] } },
          { "name": "_ebuf1", "type": { "array": ["u8", 1024] } }
        ]
      }
    },
    {
      "name": "OracleEpochInfo",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "id", "type": "u64" },
          { "name": "reserved1", "type": "u64" },
          { "name": "_reserved", "type": "u64" },
          { "name": "slash_score", "type": "u64" },
          { "name": "reward_score", "type": "u64" },
          { "name": "stake_score", "type": "u64" }
        ]
      }
    },
    {
      "name": "OracleHeartbeatEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "oracle", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "OracleHeartbeatParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "gateway_uri",
            "type": { "option": { "array": ["u8", 64] } }
          }
        ]
      }
    },
    {
      "name": "OracleHeartbeatV2Params",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "gateway_uri",
            "type": { "option": { "array": ["u8", 64] } }
          }
        ]
      }
    },
    {
      "name": "OracleInitEvent",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "oracle", "type": "pubkey" }]
      }
    },
    {
      "name": "OracleInitParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "recent_slot", "type": "u64" },
          { "name": "authority", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" },
          {
            "name": "secp_authority",
            "type": { "option": { "array": ["u8", 64] } }
          }
        ]
      }
    },
    {
      "name": "OracleInitSVMParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "recent_slot", "type": "u64" },
          { "name": "authority", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" },
          {
            "name": "secp_authority",
            "type": { "option": { "array": ["u8", 64] } }
          },
          { "name": "source_oracle_key", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "OracleQuoteOverrideEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "oracle", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "OracleQuoteRotateEvent",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "oracle", "type": "pubkey" }]
      }
    },
    {
      "name": "OracleQuoteVerifyRequestEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "quote", "type": "pubkey" },
          { "name": "oracle", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "OracleResetLutParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "recent_slot", "type": "u64" }]
      }
    },
    {
      "name": "OracleSetConfigsParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "new_authority", "type": { "option": "pubkey" } },
          {
            "name": "new_secp_authority",
            "type": { "option": { "array": ["u8", 64] } }
          }
        ]
      }
    },
    {
      "name": "OracleSetOperatorParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "OracleStatsAccountData",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "owner", "type": "pubkey" },
          { "name": "oracle", "type": "pubkey" },
          {
            "name": "finalized_epoch",
            "docs": [
              "The last epoch that has completed. cleared after registered with the",
              "staking program."
            ],
            "type": { "defined": { "name": "OracleEpochInfo" } }
          },
          {
            "name": "current_epoch",
            "docs": [
              "The current epoch info being used by the oracle. for stake. Will moved",
              "to finalized_epoch as soon as the epoch is over."
            ],
            "type": { "defined": { "name": "OracleEpochInfo" } }
          },
          {
            "name": "mega_slot_info",
            "type": { "defined": { "name": "MegaSlotInfo" } }
          },
          { "name": "last_transfer_slot", "type": "u64" },
          { "name": "bump", "type": "u8" },
          { "name": "padding1", "type": { "array": ["u8", 7] } },
          {
            "name": "_ebuf",
            "docs": ["Reserved."],
            "type": { "array": ["u8", 1024] }
          }
        ]
      }
    },
    {
      "name": "OracleSubmission",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "oracle",
            "docs": ["The public key of the oracle that submitted this value."],
            "type": "pubkey"
          },
          {
            "name": "slot",
            "docs": ["The slot at which this value was signed."],
            "type": "u64"
          },
          {
            "name": "landed_at",
            "docs": ["The slot at which this value was landed on chain."],
            "type": "u64"
          },
          {
            "name": "value",
            "docs": ["The value that was submitted."],
            "type": "i128"
          }
        ]
      }
    },
    {
      "name": "OracleSyncLutParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "PermissionSetEvent",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "permission", "type": "pubkey" }]
      }
    },
    {
      "name": "PermissionSetParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "permission", "type": "u8" },
          { "name": "enable", "type": "bool" }
        ]
      }
    },
    {
      "name": "PullFeedAccountData",
      "docs": ["A representation of the data in a pull feed account."],
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "submissions",
            "docs": ["The oracle submissions for this feed."],
            "type": {
              "array": [{ "defined": { "name": "OracleSubmission" } }, 32]
            }
          },
          {
            "name": "authority",
            "docs": [
              "The public key of the authority that can update the feed hash that",
              "this account will use for registering updates."
            ],
            "type": "pubkey"
          },
          {
            "name": "queue",
            "docs": [
              "The public key of the queue which oracles must be bound to in order to",
              "submit data to this feed."
            ],
            "type": "pubkey"
          },
          {
            "name": "feed_hash",
            "docs": [
              "SHA-256 hash of the job schema oracles will execute to produce data",
              "for this feed."
            ],
            "type": { "array": ["u8", 32] }
          },
          {
            "name": "initialized_at",
            "docs": ["The slot at which this account was initialized."],
            "type": "i64"
          },
          { "name": "permissions", "type": "u64" },
          { "name": "max_variance", "type": "u64" },
          { "name": "min_responses", "type": "u32" },
          { "name": "name", "type": { "array": ["u8", 32] } },
          { "name": "padding1", "type": { "array": ["u8", 1] } },
          { "name": "permit_write_by_authority", "type": "u8" },
          { "name": "historical_result_idx", "type": "u8" },
          { "name": "min_sample_size", "type": "u8" },
          { "name": "last_update_timestamp", "type": "i64" },
          { "name": "lut_slot", "type": "u64" },
          { "name": "_reserved1", "type": { "array": ["u8", 32] } },
          {
            "name": "result",
            "type": { "defined": { "name": "CurrentResult" } }
          },
          { "name": "max_staleness", "type": "u32" },
          { "name": "padding2", "type": { "array": ["u8", 12] } },
          {
            "name": "historical_results",
            "type": {
              "array": [{ "defined": { "name": "CompactResult" } }, 32]
            }
          },
          { "name": "_ebuf4", "type": { "array": ["u8", 8] } },
          { "name": "_ebuf3", "type": { "array": ["u8", 24] } },
          { "name": "submission_timestamps", "type": { "array": ["i64", 32] } }
        ]
      }
    },
    {
      "name": "PullFeedCloseParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "PullFeedErrorValueEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "feed", "type": "pubkey" },
          { "name": "oracle", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "PullFeedInitParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "feed_hash", "type": { "array": ["u8", 32] } },
          { "name": "max_variance", "type": "u64" },
          { "name": "min_responses", "type": "u32" },
          { "name": "name", "type": { "array": ["u8", 32] } },
          { "name": "recent_slot", "type": "u64" },
          { "name": "ipfs_hash", "type": { "array": ["u8", 32] } },
          { "name": "min_sample_size", "type": "u8" },
          { "name": "max_staleness", "type": "u32" },
          { "name": "permit_write_by_authority", "type": { "option": "bool" } }
        ]
      }
    },
    {
      "name": "PullFeedSetConfigsParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "feed_hash",
            "type": { "option": { "array": ["u8", 32] } }
          },
          { "name": "authority", "type": { "option": "pubkey" } },
          { "name": "max_variance", "type": { "option": "u64" } },
          { "name": "min_responses", "type": { "option": "u32" } },
          { "name": "name", "type": { "option": { "array": ["u8", 32] } } },
          {
            "name": "ipfs_hash",
            "type": { "option": { "array": ["u8", 32] } }
          },
          { "name": "min_sample_size", "type": { "option": "u8" } },
          { "name": "max_staleness", "type": { "option": "u32" } },
          { "name": "permit_write_by_authority", "type": { "option": "bool" } }
        ]
      }
    },
    {
      "name": "PullFeedSubmitResponseConsensusLightParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "slot", "type": "u64" },
          { "name": "values", "type": { "vec": "i128" } }
        ]
      }
    },
    {
      "name": "PullFeedSubmitResponseConsensusParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "slot", "type": "u64" },
          { "name": "values", "type": { "vec": "i128" } }
        ]
      }
    },
    {
      "name": "PullFeedSubmitResponseManyParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "slot", "type": "u64" },
          {
            "name": "submissions",
            "type": { "vec": { "defined": { "name": "MultiSubmission" } } }
          }
        ]
      }
    },
    {
      "name": "PullFeedSubmitResponseParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "slot", "type": "u64" },
          {
            "name": "submissions",
            "type": {
              "vec": {
                "defined": {
                  "name": "sb_on_demand::actions::pull_feed::pull_feed_submit_response_action::Submission"
                }
              }
            }
          }
        ]
      }
    },
    {
      "name": "PullFeedSubmitResponseSVMParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "slot", "type": "u64" },
          {
            "name": "submissions",
            "type": {
              "vec": {
                "defined": {
                  "name": "sb_on_demand::actions::pull_feed::pull_feed_submit_response_svm_action::Submission"
                }
              }
            }
          },
          { "name": "source_queue_key", "type": "pubkey" },
          { "name": "queue_bump", "type": "u8" }
        ]
      }
    },
    {
      "name": "PullFeedValueEvents",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "feeds", "type": { "vec": "pubkey" } },
          { "name": "oracles", "type": { "vec": "pubkey" } },
          { "name": "values", "type": { "vec": { "vec": "i128" } } },
          { "name": "reward", "type": "u32" }
        ]
      }
    },
    {
      "name": "QueueAccountData",
      "docs": [
        "An Queue represents a round-robin queue of oracle oracles who attest on-chain",
        "whether a Switchboard Function was executed within an enclave against an expected set of",
        "enclave measurements.",
        "",
        "For an oracle to join the queue, the oracle must first submit their enclave quote on-chain and",
        "wait for an existing oracle to attest their quote. If the oracle's quote matches an expected",
        "measurement within the queues mr_enclaves config, it is granted permissions and will start",
        "being assigned update requests."
      ],
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority",
            "docs": [
              "The address of the authority which is permitted to add/remove allowed enclave measurements."
            ],
            "type": "pubkey"
          },
          {
            "name": "mr_enclaves",
            "docs": ["Allowed enclave measurements."],
            "type": { "array": [{ "array": ["u8", 32] }, 32] }
          },
          {
            "name": "oracle_keys",
            "docs": [
              "The addresses of the quote oracles who have a valid",
              "verification status and have heartbeated on-chain recently."
            ],
            "type": { "array": ["pubkey", 128] }
          },
          {
            "name": "max_quote_verification_age",
            "docs": [
              "The maximum allowable time until a EnclaveAccount needs to be re-verified on-chain."
            ],
            "type": "i64"
          },
          {
            "name": "last_heartbeat",
            "docs": [
              "The unix timestamp when the last quote oracle heartbeated on-chain."
            ],
            "type": "i64"
          },
          { "name": "node_timeout", "type": "i64" },
          {
            "name": "oracle_min_stake",
            "docs": [
              "The minimum number of lamports a quote oracle needs to lock-up in order to heartbeat and verify other quotes."
            ],
            "type": "u64"
          },
          { "name": "allow_authority_override_after", "type": "i64" },
          {
            "name": "mr_enclaves_len",
            "docs": ["The number of allowed enclave measurements."],
            "type": "u32"
          },
          {
            "name": "oracle_keys_len",
            "docs": [
              "The length of valid quote oracles for the given attestation queue."
            ],
            "type": "u32"
          },
          {
            "name": "reward",
            "docs": [
              "The reward paid to quote oracles for attesting on-chain."
            ],
            "type": "u32"
          },
          {
            "name": "curr_idx",
            "docs": [
              "Incrementer used to track the current quote oracle permitted to run any available functions."
            ],
            "type": "u32"
          },
          {
            "name": "gc_idx",
            "docs": [
              "Incrementer used to garbage collect and remove stale quote oracles."
            ],
            "type": "u32"
          },
          { "name": "require_authority_heartbeat_permission", "type": "u8" },
          { "name": "require_authority_verify_permission", "type": "u8" },
          { "name": "require_usage_permissions", "type": "u8" },
          { "name": "signer_bump", "type": "u8" },
          { "name": "mint", "type": "pubkey" },
          { "name": "lut_slot", "type": "u64" },
          { "name": "allow_subsidies", "type": "u8" },
          { "name": "_ebuf6", "type": { "array": ["u8", 15] } },
          { "name": "ncn", "type": "pubkey" },
          { "name": "_resrved", "type": "u64" },
          {
            "name": "vaults",
            "type": { "array": [{ "defined": { "name": "VaultInfo" } }, 4] }
          },
          { "name": "_ebuf4", "type": { "array": ["u8", 32] } },
          { "name": "_ebuf2", "type": { "array": ["u8", 256] } },
          { "name": "_ebuf1", "type": { "array": ["u8", 512] } }
        ]
      }
    },
    {
      "name": "QueueAddMrEnclaveEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "queue", "type": "pubkey" },
          { "name": "mr_enclave", "type": { "array": ["u8", 32] } }
        ]
      }
    },
    {
      "name": "QueueAddMrEnclaveParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "mr_enclave", "type": { "array": ["u8", 32] } }]
      }
    },
    {
      "name": "QueueAllowSubsidiesParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "allow_subsidies", "type": "u8" }]
      }
    },
    {
      "name": "QueueGarbageCollectParams",
      "type": { "kind": "struct", "fields": [{ "name": "idx", "type": "u32" }] }
    },
    {
      "name": "QueueInitEvent",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "queue", "type": "pubkey" }]
      }
    },
    {
      "name": "QueueInitParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "allow_authority_override_after", "type": "u32" },
          { "name": "require_authority_heartbeat_permission", "type": "bool" },
          { "name": "require_usage_permissions", "type": "bool" },
          { "name": "max_quote_verification_age", "type": "u32" },
          { "name": "reward", "type": "u32" },
          { "name": "node_timeout", "type": "u32" },
          { "name": "recent_slot", "type": "u64" }
        ]
      }
    },
    {
      "name": "QueueInitSVMParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "allow_authority_override_after", "type": "u32" },
          { "name": "require_authority_heartbeat_permission", "type": "bool" },
          { "name": "require_usage_permissions", "type": "bool" },
          { "name": "max_quote_verification_age", "type": "u32" },
          { "name": "reward", "type": "u32" },
          { "name": "node_timeout", "type": "u32" },
          { "name": "recent_slot", "type": "u64" },
          { "name": "source_queue_key", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "QueueOverrideSVMParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "secp256k1_signer", "type": { "array": ["u8", 64] } },
          { "name": "max_quote_verification_age", "type": "i64" },
          { "name": "mr_enclave", "type": { "array": ["u8", 32] } },
          { "name": "slot", "type": "u64" }
        ]
      }
    },
    {
      "name": "QueuePaySubsidyParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "QueueRemoveMrEnclaveEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "queue", "type": "pubkey" },
          { "name": "mr_enclave", "type": { "array": ["u8", 32] } }
        ]
      }
    },
    {
      "name": "QueueRemoveMrEnclaveParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "mr_enclave", "type": { "array": ["u8", 32] } }]
      }
    },
    {
      "name": "QueueResetVaultParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "QueueSetConfigsParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "authority", "type": { "option": "pubkey" } },
          { "name": "reward", "type": { "option": "u32" } },
          { "name": "node_timeout", "type": { "option": "i64" } }
        ]
      }
    },
    { "name": "QueueSetNcnParams", "type": { "kind": "struct", "fields": [] } },
    {
      "name": "QueueSetVaultParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "enable", "type": "bool" }]
      }
    },
    {
      "name": "Quote",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "enclave_signer",
            "docs": ["The address of the signer generated within an enclave."],
            "type": "pubkey"
          },
          {
            "name": "mr_enclave",
            "docs": [
              "The quotes MRENCLAVE measurement dictating the contents of the secure enclave."
            ],
            "type": { "array": ["u8", 32] }
          },
          {
            "name": "verification_status",
            "docs": ["The VerificationStatus of the quote."],
            "type": "u8"
          },
          { "name": "padding1", "type": { "array": ["u8", 7] } },
          {
            "name": "verification_timestamp",
            "docs": ["The unix timestamp when the quote was last verified."],
            "type": "i64"
          },
          {
            "name": "valid_until",
            "docs": [
              "The unix timestamp when the quotes verification status expires."
            ],
            "type": "i64"
          },
          {
            "name": "quote_registry",
            "docs": [
              "The off-chain registry where the verifiers quote can be located."
            ],
            "type": { "array": ["u8", 32] }
          },
          {
            "name": "registry_key",
            "docs": [
              "Key to lookup the buffer data on IPFS or an alternative decentralized storage solution."
            ],
            "type": { "array": ["u8", 64] }
          },
          {
            "name": "secp256k1_signer",
            "docs": [
              "The secp256k1 public key of the enclave signer. Derived from the enclave_signer."
            ],
            "type": { "array": ["u8", 64] }
          },
          { "name": "last_ed25519_signer", "type": "pubkey" },
          { "name": "last_secp256k1_signer", "type": { "array": ["u8", 64] } },
          { "name": "last_rotate_slot", "type": "u64" },
          { "name": "guardian_approvers", "type": { "array": ["pubkey", 64] } },
          { "name": "guardian_approvers_len", "type": "u8" },
          { "name": "padding2", "type": { "array": ["u8", 7] } },
          { "name": "staging_ed25519_signer", "type": "pubkey" },
          {
            "name": "staging_secp256k1_signer",
            "type": { "array": ["u8", 64] }
          },
          { "name": "eth_signer", "type": { "array": ["u8", 20] } },
          {
            "name": "_ebuf4",
            "docs": ["Reserved."],
            "type": { "array": ["u8", 12] }
          },
          { "name": "_ebuf3", "type": { "array": ["u8", 128] } },
          { "name": "_ebuf2", "type": { "array": ["u8", 256] } },
          { "name": "_ebuf1", "type": { "array": ["u8", 512] } }
        ]
      }
    },
    {
      "name": "RandomnessAccountData",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "authority", "type": "pubkey" },
          { "name": "queue", "type": "pubkey" },
          { "name": "seed_slothash", "type": { "array": ["u8", 32] } },
          { "name": "seed_slot", "type": "u64" },
          { "name": "oracle", "type": "pubkey" },
          { "name": "reveal_slot", "type": "u64" },
          { "name": "value", "type": { "array": ["u8", 32] } },
          { "name": "lut_slot", "type": "u64" },
          { "name": "_ebuf3", "type": { "array": ["u8", 24] } },
          { "name": "_ebuf2", "type": { "array": ["u8", 64] } },
          { "name": "_ebuf1", "type": { "array": ["u8", 128] } },
          {
            "name": "active_secp256k1_signer",
            "type": { "array": ["u8", 64] }
          },
          { "name": "active_secp256k1_expiration", "type": "i64" }
        ]
      }
    },
    {
      "name": "RandomnessCommitEvent",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "randomness_account", "type": "pubkey" },
          { "name": "oracle", "type": "pubkey" },
          { "name": "slot", "type": "u64" },
          { "name": "slothash", "type": { "array": ["u8", 32] } }
        ]
      }
    },
    {
      "name": "RandomnessCommitParams",
      "type": { "kind": "struct", "fields": [] }
    },
    {
      "name": "RandomnessInitParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "recent_slot", "type": "u64" }]
      }
    },
    {
      "name": "RandomnessRevealParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "signature", "type": { "array": ["u8", 64] } },
          { "name": "recovery_id", "type": "u8" },
          { "name": "value", "type": { "array": ["u8", 32] } }
        ]
      }
    },
    {
      "name": "State",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "bump", "type": "u8" },
          { "name": "test_only_disable_mr_enclave_check", "type": "u8" },
          { "name": "enable_staking", "type": "u8" },
          { "name": "padding1", "type": { "array": ["u8", 5] } },
          { "name": "authority", "type": "pubkey" },
          { "name": "guardian_queue", "type": "pubkey" },
          { "name": "reserved1", "type": "u64" },
          { "name": "epoch_length", "type": "u64" },
          { "name": "reserved2", "type": { "array": ["u8", 136] } },
          { "name": "switch_mint", "type": "pubkey" },
          { "name": "sgx_advisories", "type": { "array": ["u16", 32] } },
          { "name": "advisories_len", "type": "u8" },
          { "name": "padding2", "type": "u8" },
          { "name": "flat_reward_cut_percentage", "type": "u8" },
          { "name": "enable_slashing", "type": "u8" },
          { "name": "padding3", "type": "u32" },
          { "name": "lut_slot", "type": "u64" },
          { "name": "base_reward", "type": "u32" },
          { "name": "padding4", "type": { "array": ["u8", 4] } },
          { "name": "subsidy_amount", "type": "u64" },
          { "name": "_ebuf6", "type": { "array": ["u8", 16] } },
          { "name": "_ebuf5", "type": { "array": ["u8", 32] } },
          { "name": "_ebuf4", "type": { "array": ["u8", 64] } },
          { "name": "_ebuf3", "type": { "array": ["u8", 128] } },
          { "name": "_ebuf2", "type": { "array": ["u8", 512] } },
          {
            "name": "cost_whitelist",
            "docs": ["Cost whitelist by authority"],
            "type": { "array": ["pubkey", 32] }
          }
        ]
      }
    },
    { "name": "StateInitParams", "type": { "kind": "struct", "fields": [] } },
    {
      "name": "StateSetConfigsParams",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "new_authority", "type": "pubkey" },
          { "name": "test_only_disable_mr_enclave_check", "type": "u8" },
          { "name": "add_advisory", "type": "u16" },
          { "name": "rm_advisory", "type": "u16" },
          { "name": "switch_mint", "type": "pubkey" },
          { "name": "subsidy_amount", "type": "u64" },
          { "name": "base_reward", "type": "u32" },
          { "name": "add_cost_wl", "type": "pubkey" },
          { "name": "rm_cost_wl", "type": "pubkey" }
        ]
      }
    },
    {
      "name": "TestUpdateOracleStatsParams",
      "type": {
        "kind": "struct",
        "fields": [{ "name": "new_reward_score", "type": "u64" }]
      }
    },
    {
      "name": "VaultInfo",
      "serialization": "bytemuck",
      "repr": { "kind": "c" },
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "vault_key", "type": "pubkey" },
          { "name": "last_reward_epoch", "type": "u64" }
        ]
      }
    },
    {
      "name": "sb_on_demand::actions::pull_feed::pull_feed_submit_response_action::Submission",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "value", "type": "i128" },
          { "name": "signature", "type": { "array": ["u8", 64] } },
          { "name": "recovery_id", "type": "u8" },
          { "name": "offset", "type": "u8" }
        ]
      }
    },
    {
      "name": "sb_on_demand::actions::pull_feed::pull_feed_submit_response_svm_action::Submission",
      "type": {
        "kind": "struct",
        "fields": [
          { "name": "value", "type": "i128" },
          { "name": "signature", "type": { "array": ["u8", 64] } },
          { "name": "recovery_id", "type": "u8" }
        ]
      }
    }
  ]
}
